import React from "react";
import OwlCarousel from "react-owl-carousel";
import Search from './Search'
import {
  DayTour,
  MultiTour,
  ThingsToDo,
  Transfer,
  RentCAr,
  Maldives
} from '../../Images'
import { API_URL } from '../../Actions/Config';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Slider = (props) => {
  const options = {
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    dots: false,
    nav: true,
    navText: [
      '<span className="custom-arrow">&#8249;</span>',
      '<span className="custom-arrow">&#8250;</span>'
    ]
  };

  return (
    <section className="slider">
      <Search />
      <OwlCarousel className="owl-carousel owl-theme" {...options} id="owl-slider" key={props.sliders.length}>

        {props.sliders.map((slider, index) => (
          <div className="item" key={index}>
            <div className="header-logo-wrap container">
              <div className="heade-logos">
                <a href={slider.link} target="_blank" rel="noreferrer">
                  <img
                    src={API_URL + "/uploads/slider_images/logo/" + slider.logo}
                    width="170"
                    alt="Beyond Escapes"
                  />
                </a>
              </div>
            </div>
            <div className="slid-itm">
              <img
                src={API_URL + "/uploads/slider_images/" + slider.image}
                alt="Slide 1"
                width="100%"
              />
            </div>
          </div>
        ))}


      </OwlCarousel>
    </section>
  );
};

export default Slider;
